import { feedbotToast } from '../../lib/feedbotToast'

export const toastNlpTestStarted = () => {
  const id = 'nlpTestStarted'

  const title = 'NLP test is in progress...'

  const content = ''

  feedbotToast.info({ title, content, id, config: { autoClose: false } })

  return id
}

export const toastNlpTestError = () => {
  const id = 'nlpTestError'

  const title = 'Failed to run NLP test'

  const content = 'See browser console for more details or contact support.'

  feedbotToast.error({ title, content, id })

  return id
}
